import { useContext, useEffect } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { BannerType, BannerView } from "@dotnet/telematics-design-system";

import Tag, { TAG_COLORS, TAG_SIZES } from "components/DesignComponents/Tag";
import TableContext from "context/table/tableContext";
import TriSourceContext from "context/triSource/triSourceContext";
import { useFormattedNumber } from "shared/hooks/useFormattedNumber";
import { TRI_SOURCES } from "shared/types/enums";

import { TriSourceTabProps } from "../types";

const Selected = ({ description, setCount }: TriSourceTabProps) => {
    const { tableName, selectedRows } = useContext(TableContext);
    const { handleNeedConfirmation } = useContext(TriSourceContext);

    const { t } = useTranslation();
    const { renderFormattedNumber } = useFormattedNumber();

    const numberOfSelectedRows = selectedRows.length;

    // Check if confirmation is required
    useEffect(() => {
        handleNeedConfirmation(numberOfSelectedRows > 20);
        setCount?.(numberOfSelectedRows);
    }, [numberOfSelectedRows, handleNeedConfirmation, setCount]);

    const title = `${t(
        `Dialog##selected ${tableName}`
    )}: ${renderFormattedNumber(numberOfSelectedRows)}`;

    return (
        <div data-testid={`tri-source-${TRI_SOURCES.Selected}`}>
            <BannerView
                bannerType={BannerType.Info}
                title={t(
                    `Dialog##tri source##selected tab description##${description}`
                )}
                css={css({ marginBottom: "16px" })}
            />

            <Tag
                data-testid="tag-selected"
                size={TAG_SIZES.Medium}
                color={TAG_COLORS.Primary}
                title={title}
            />
        </div>
    );
};

export default Selected;
